'use client';

import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { Button } from '@mui/material';

// import { userRegisterSchema } from 'src/utils/validations';

import { Form, Field } from 'src/components/hook-form';
import { useLocale } from 'src/locales';
import { createSchemas } from 'src/utils/use-validations';

export function UserRegister({ open, onClose, registerUser, loading }) {
  const defaultValues = {
    name: '',
    email: '',
  };

  const { userRegisterSchema } = createSchemas();

  const methods = useForm({
    resolver: zodResolver(userRegisterSchema),
    defaultValues,
    mode: 'all',
  });

  const { t } = useLocale();

  const {
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { isSubmitting, isValid },
  } = methods;

  useEffect(() => {
    if (open) {
      reset();
    }
  }, [open, reset]);

  const onSubmit = handleSubmit(async (data) => {
    registerUser({ name: data.name, email: data.email });
  });

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <Field.Text name="name" label={t('Name')} required sx={{ my: 2 }} />
      <Field.Text name="email" label={t('Email')} required sx={{ my: 2 }} />

      <Button
        fullWidth
        color="primary"
        size="large"
        type="submit"
        variant="contained"
        loading={loading}
        disabled={isSubmitting || loading}
        sx={{
          '& .MuiCircularProgress-root': {
            color: '#0d9d57', // change loader colour here
            width: '20px !important',
            height: '20px !important',
          },
        }}
      >
        {t('Create_Account')}
      </Button>
    </Form>
  );
}
